import { useCallback, useEffect } from "react";
import { ResponseData } from "@api/internal/utils/types";
import { useDelayedComponents } from "@hooks/useDelayedComponents";
import { FeedSetReadingHistoryResponse } from "@pages/MyAccount/utils/types";
import useOKTAUserStore from "@store/useOKTAUserStore";
import axios from "axios";

type useSetReadingHistoryProps = {
  /** Article id to set the reading history  */
  articleId: string;
};

/**
 * Hook to set reading history for a user.
 */
export const useSetReadingHistory = ({
  articleId,
}: useSetReadingHistoryProps) => {
  const { isShown } = useDelayedComponents(800);
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const visitorId = OKTAUserInfo?.mysphw;

  const sendReadingHistoryData = useCallback(
    async (articleId: string) => {
      const payload = {
        articleId: articleId,
      };

      const response = await axios
        .post<ResponseData<FeedSetReadingHistoryResponse>>(
          "/_plat/api/v1/user/reading-history",
          payload,
          {
            headers: {
              aovisitorid: visitorId,
            },
          }
        )
        .then((data) => data.data);

      if (!response.success) {
        // eslint-disable-next-line no-console
        console.error(
          `Error setting reading history - ${JSON.stringify({ payload, response })}`
        );
      }
    },
    [visitorId]
  );

  useEffect(() => {
    if (!isShown) return;
    if (typeof articleId !== "string") return;
    if (!visitorId) return;

    sendReadingHistoryData(articleId);
  }, [sendReadingHistoryData, articleId, visitorId, isShown]);
};
